import infoIcon from '~/assets/icons/info-white.svg';

type LoginCartItem = {
    id: string;
    referencedId: string;
    label: string;
    quantity: number;
};

export function snapshotCartBeforeLogin() {
    const { cartItems } = useCart();
    sessionStorage.setItem('preLoginCart', JSON.stringify({ items: cartItems.value }));
}

export async function handlePostLogin() {
    const { t } = useI18n();
    const { refreshCart } = useCart();
    const preLoginCart = JSON.parse(sessionStorage.getItem('preLoginCart') || 'null');

    if (!preLoginCart) return;

    const freshCart = await refreshCart();

    const postRefs = new Set(freshCart.lineItems?.map((li) => li.referencedId ?? li.id) ?? []);
    const missing: LoginCartItem[] = preLoginCart.items.filter((i: LoginCartItem) => !postRefs.has(i.referencedId));

    if (missing.length === 0) {
        sessionStorage.removeItem('preLoginCart');
        return;
    }

    useToast().info({
        color: '#fff',
        title: t('cart.restrictionNotification.title'),
        message: t('cart.restrictionNotification.message'),
        // @ts-expect-error The property DOES exist and is supported
        iconUrl: infoIcon,
        animateInside: false,
        timeout: 5500,
        position: 'topRight',
        class: 'notification info',
        progressBarColor: 'rgb(70, 160, 175)'
    });

    sessionStorage.removeItem('preLoginCart');
}
